import styled from "styled-components";

export const Fullbleed = styled.div`
  grid-area: fullbody / fullbleed;
`;
